module.exports = __webpack_public_path__ + "img/redcart.74d09725.svg";